module.exports = __webpack_public_path__ + "static/media/reset-password.8d19022d.svg";